const types = {
  AUTH_CHECK: "AUTH_CHECK",
  AUTH_REQUEST: "AUTH_REQUEST",
  AUTH_SUCCESS: "AUTH_SUCCESS",
  AUTH_FAIL: "AUTH_FAIL",
  AUTH_SET: "AUTH_SET",
  AUTH_UNSET: "AUTH_UNSET",
  AUTH_STATE: "AUTH_STATE",
  AUTH_SET_ERRORS: "AUTH_SET_ERRORS",
  AUTH_SET_COOKIE: "AUTH_SET_COOKIE"
};

export default types;
